import React from "react";
import { createRoot } from "react-dom/client";
import { App } from "./ui/App";
import {
  color,
  font,
  installThemeCss,
  applyTheme,
  readThemeMode,
  applyFontSize,
  readFontSizeMode,
} from "./ui/theme";
import { initLang } from "./i18n";

// Применяем тему ДО первого рендера, иначе будет вспышка светлой темы
// при запуске в тёмной. installThemeCss вставляет переменные, applyTheme
// ставит data-theme на <html>.
installThemeCss();
applyTheme(readThemeMode());
applyFontSize(readFontSizeMode());

// Применяем язык ДО первого рендера, чтобы интерфейс сразу рисовался
// на нужном языке. initLang НЕ пишет в localStorage: туда попадает только
// осознанный выбор в профиле, иначе определённый язык залипал бы навсегда.
initLang();

// System notifications in installed PWAs and Safari/WebKit must be emitted
// by an active service worker. The page-level Notification constructor alone
// is not a reliable background delivery channel.
if ("serviceWorker" in navigator) {
  // sw.js also serves one-shot same-origin attachment downloads. Bypass the
  // HTTP cache so a freshly deployed page does not keep talking to an older
  // notification-only worker; an already open app still needs one reload when
  // the controller changes.
  void navigator.serviceWorker.register("/sw.js", { updateViaCache: "none" }).catch((error) => {
    console.warn("[notifications] service worker registration failed:", error);
  });
}

/**
 * Базовые глобальные стили — единственный «ручной» CSS вне компонентов.
 * Здесь только то, что нельзя выразить inline-стилем React:
 *  - ::selection (псевдоэлемент) — цвет выделения из токена highlight;
 *  - фон body за пределами #root (overscroll, полосы прокрутки).
 * box-sizing сознательно НЕ трогаем: часть раскладки рассчитана под
 * content-box (см. комментарий в MediaViewer), и глобальный border-box
 * здесь — уже раскладка, а это этапы 2–4.
 * Цвета берутся из тех же токенов, что и весь интерфейс: два источника
 * правды недопустимы ровно так же, как в roomListCss.
 */
const baseCss = `
  html, body, #root { height: 100%; margin: 0; }
  html, body { overflow: hidden; }
  body {
    background: ${color.bg};
    color: ${color.text};
    font-family: ${font.family};
    font-size: ${font.body}px;
    -webkit-font-smoothing: antialiased;
  }
  ::selection { background: ${color.highlight}; }
`;
const styleEl = document.createElement("style");
styleEl.setAttribute("data-alg-base", "1");
styleEl.textContent = baseCss;
document.head.appendChild(styleEl);

const el = document.getElementById("root");
if (!el) throw new Error("no #root in index.html");
createRoot(el).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
